import { render, staticRenderFns } from "./BaseNumericTag.vue?vue&type=template&id=f2c3370e&"
import script from "./BaseNumericTag.vue?vue&type=script&lang=ts&"
export * from "./BaseNumericTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports